import * as React from 'react';
import { useHistory } from 'react-router-dom';
import './style.scss';

interface SymbolSearchProps {}

export const SymbolSearchComponent: React.FC<SymbolSearchProps> = () => {
    const history = useHistory();
    const [searchInput, setSearchInput] = React.useState('');
    const inputRef = React.useRef<HTMLInputElement>(null);

    const handleSearch = (e: React.FormEvent) => {
        e.preventDefault();
        if (searchInput.trim()) {
            const symbol = searchInput.trim().toUpperCase();
            history.push(`/symbol/${symbol}`);
            setSearchInput('');
        }
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchInput(e.target.value);
    };

    const handleBlur = () => {
        // Keep input value on blur
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Escape') {
            setSearchInput('');
        }
    };

    const handleClear = () => {
        setSearchInput('');
        inputRef.current?.focus();
    };

    return (
        <div className="symbol-search">
            <form onSubmit={handleSearch} className="search-form">
                <div className="search-input-wrapper">
                    <i className='bx bx-search-alt-2'></i>
                    <input
                        ref={inputRef}
                        type="text"
                        placeholder="Search symbol..."
                        value={searchInput}
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                        onKeyDown={handleKeyDown}
                        className="search-input"
                    />
                    {searchInput && (
                        <i 
                            className='bx bx-x'
                            onClick={handleClear}
                            style={{ cursor: 'pointer' }}
                        ></i>
                    )}
                </div>
            </form>
        </div>
    );
};
